import { IconButton, Tooltip } from '@dixa/lib-shared-habla';
import { useMemo } from 'react';

import { askSidekick } from 'utils/sidekick';

import { createAiAgentDebugPrompt } from './sidekickDebugButton.utils';
import { useSidekickAiAgent } from './useAskSidekickToDraft';

const LABEL = 'Ask Sidekick about this reply';
const ASK_TITLE = 'Analyze this reply';
const ASK_LABEL = 'What would you like to analyze?';
const ASK_PLACEHOLDER =
  "For example: where is this answer coming from, why it cited the wrong refund policy, why did it say 'XYZ'";

type SidekickReplyDebugButtonProps = {
  /** The id of the user that sent the message. */
  authorId: string;
  /** The id of the conversation the message belongs to. */
  csid: string;
  /** The id of the message. */
  messageId: string;
  /** When the message was sent. */
  date?: string;
};

/** Lets the user debug a message sent by an AI agent with Sidekick. */
export const SidekickReplyDebugButton = ({
  authorId,
  csid,
  messageId,
  date,
}: SidekickReplyDebugButtonProps): JSX.Element | null => {
  const aiAgent = useSidekickAiAgent(useMemo(() => [authorId], [authorId]));

  if (!aiAgent) return null;

  const debug = () =>
    askSidekick({
      title: ASK_TITLE,
      label: ASK_LABEL,
      placeholder: ASK_PLACEHOLDER,
      createPrompt: (answer) =>
        createAiAgentDebugPrompt({ csid, messageId, date, note: answer }),
    });

  return (
    <Tooltip wrap="span" content={LABEL}>
      <IconButton
        variant="tertiary"
        icon="mim-sidekick"
        aria-label={LABEL}
        onClick={debug}
      />
    </Tooltip>
  );
};
